/* global axios */
export const projectService = {
	index
}

function index(params = '') {
	// return axios.get('/users/me/projects' + params)
	return axios.get('/projects' + params)
}
